import { BaseService } from '@estee/elc-service';
import { ServiceInitializer } from '@estee/elc-universal-utils';

const { name, version } = __serviceInfo__;

export class ProductUgcService extends BaseService {
    constructor(serviceInitializer: ServiceInitializer) {
        super(name, version, serviceInitializer);
    }
}

export default {
    productUgcService: 'PRODUCT_UGC_SERVICE',
    configStore: 'CONFIG_STORE',
    config: 'CONFIG',
    configRepository: 'CONFIG_REPOSITORY',
    olapicWidgetViewController: 'OLAPIC_WIDGET_VIEW_CONTROLLER'
};
